<div class="header">
    <div class="brand">
        <div class="logo-container">
            <div class="accuris-logo"></div>
        </div>
        <h1 class="display-sm-30-semibold title">Accuris AI Assistant - Component Research Agent</h1>
    </div>
</div>
